import { useState } from 'react';
// @mui
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
//
import { MILES_SOURCES, MilesSource } from 'src/models';
import SourcePicker from './source-picker';
import StepTitle from './step-title';

// ----------------------------------------------------------------------

type Props = {
  onBack?: () => void;
  initialSource: MilesSource;
  saving: boolean;
  onSave: (source: MilesSource) => void;
};

export default function StepMilesSource({ initialSource, saving, onSave, onBack }: Props) {
  const [source, setSource] = useState<MilesSource>(initialSource);

  return (
    <Stack spacing={3}>
      <StepTitle title="Where should we get your miles from?" onBack={onBack} />

      <SourcePicker
        options={MILES_SOURCES}
        value={source}
        onSelect={(value) => setSource(value as MilesSource)}
      />

      <Button
        variant="contained"
        color="secondary"
        size="large"
        disabled={!source || saving}
        onClick={() => onSave(source)}
        sx={{ alignSelf: 'flex-start' }}
        data-testid="source-continue"
      >
        Continue
      </Button>
    </Stack>
  );
}
